
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useAuthState } from '../../../../../../Helper/Context';
import { RegExOnlyText } from '../../../../../../Helper/regEx/RegExOnlyText';
import { AstricSign } from '../../../../../../Helper/AstricSign';
import { WorkNameDDL } from '../../../../../../Components/CommonDDL/WorkNameDDL';
import { LocationDDL } from '../../../../../../Components/CommonDDL/LocationDDL';
import { WardNameDataDDL } from '../../../../../../Components/CommonDDL/WardNameDataDDL';
import { LocationNameEleMasterPostDataAPI } from '../../../../../../Redux/ElectricalSlice/LocationSlice';
import { Loading } from '../../../../../../Helper/Loading';


export default function AddElectricLocationPopUp(props) {

    const { item, EditIcon, Flag, handleIsPost, rowData, open, handleOnCloseClick } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch();

    // const [rowData, setRowData] = useState(Flag === 'Update' ? item : '')

    console.log('rowData', rowData)

    const [LocationName, setLocationName] = useState(Flag === 'Update' ? rowData?.locationName : '')

    const [loading, setloading] = useState(false)

    const [WardName, setWardName] = useState({
        DDL: [],
        ID: '0',
        Label: "Select...",
    })


    const handlePost = () => {
        const data = {
            M_ELEC_LocationID: rowData?.m_eleC_LocationID,
            M_WardID: WardName?.ID,
            LocationName: LocationName,
            M_UserID: UserID,
            token: token,
            Flag: Flag,
            setLoading: setloading,
            handleIsPost: handleIsPost,
            handleOnCloseClick: handleOnCloseClick
        }
        dispatch(LocationNameEleMasterPostDataAPI({ data }))
    }

    const [IsValidText, setIsValidText] = useState(false)

    const handleCheckText = (e) => {
        setLocationName(e.target.value)
        const IsValid = RegExOnlyText(e.target.value)
        setIsValidText(IsValid)
        return IsValid
    }

    return (


        <Popup
            open={open} closeOnDocumentClick={false} onClose={handleOnCloseClick}
        >
            <div className="area_pop modal-dialog modal-dialog-scrollable modal-xl">
                <div className="modal-content master_border">
                    <div className="modal-header pl-4 p-1">
                        <h5 className="modal-title pt-1" id="staticBackdropLabel">{Flag === "Update" ? "Update" : "Add"} Location</h5>
                        <button onClick={handleOnCloseClick} className="btn-close m-1 mr-3" type="button" />
                    </div>

                    {loading && <Loading />}

                    <div className="modal-body">
                        <div className='inner-modal-body'>

                            <div className="row details-row col-12 ">

                                <div className="col-12">
                                    <div className="form-group">
                                        <WardNameDataDDL
                                            WardName={WardName}
                                            setWardName={setWardName}
                                            HWard='0'
                                            WLable=''
                                            Type="Electrical"
                                            APIFlag="Master"
                                            Flag={Flag}
                                            rowData={rowData}
                                        />
                                    </div>
                                </div>

                                <div className="col-12">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Location Name <AstricSign /> </b></label>
                                        <input type="text"
                                            className="form-control"
                                            id="LocationName"
                                            value={LocationName}
                                            // onChange={(e) => handleCheckText(e)}
                                            onChange={(e) => setLocationName(e.target.value)}
                                        />
                                        {
                                            IsValidText && <text className='text-danger' style={{ fontSize: '13px' }}>Location Name is invalid</text>
                                        }
                                    </div>
                                </div>
                                {/* } */}

                            </div>

                            <div className="col-12 col-lg-12">
                                <div className="btn-action d-flex justify-content-end mt-lg-3">

                                    <button type='button'
                                        className="btn allBtn  float-right submit_btn"
                                        onClick={() => handlePost()}
                                        disabled={
                                            LocationName == '' || WardName?.ID == 0 || IsValidText
                                        }
                                    >{Flag === "Update" ? "Update" : "Add"} </button>

                                    <button type="button" className="btn addBtns cancel_btn ms-2 mr-2 mx-2  float-right" onClick={handleOnCloseClick} >Cancel</button>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>

            {/* )} */}


        </Popup>
    )

}